import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { saInterCuIntraFreqHandoutCellChartConfig } from '../cellChartConfigs';

interface InterCuIntraFreqHandoutSaCellProps {
  cellName: string;
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const InterCuIntraFreqHandoutSaCell: React.FC<InterCuIntraFreqHandoutSaCellProps> = ({ cellName, onFullscreenToggle, isFullscreen }) => {
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);
  return (
    <SiteCharts config={saInterCuIntraFreqHandoutCellChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} additionalParams={additionalParams} />
  );
};

export default InterCuIntraFreqHandoutSaCell;
